import palette from '../palette';

export default {
  root: {
    margin: '3px'
  }
};